import { RootState } from 'store';

export const selectHealthCheckFiles = ({
	generateHealthCheckFiles,
}: RootState) => generateHealthCheckFiles;

export const selectActiveStep = ({
	generateHealthCheck: { activeStep },
}: RootState) => activeStep;

export const selectLocation = ({
	generateHealthCheck: { location },
}: RootState) => location;

export const selectIsFinalized = ({
	generateHealthCheck: { isFinalized },
}: RootState) => isFinalized;

export const selectHealthCheckId = ({
	generateHealthCheck: { id },
}: RootState) => id;
